import React, { FC, useEffect } from 'react';
import Prism from 'prismjs';
import { Typography } from '@mui/material';
import htmlSanitizer from '../../../lib/helpers/html.helper';
import './prism.scss';
import './ContentRenderer.scss';

type ContentRendererProps = {
	html: string;
	textColor?: string;
	className?: string;
};

const ContentRenderer: FC<ContentRendererProps> = ({
	html,
	textColor,
	className,
}) => {
	useEffect(() => {
		Prism.highlightAll();
	}, [html]);
	const sanitizedHTML = htmlSanitizer(html);

	return (
		<Typography
			variant="body1"
			component="div"
			className={`RichEditorContent ${className || ''}`}
			style={{ color: textColor }}
			dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
		/>
	);
};

export default ContentRenderer;
